<div class="home-page">
    <section class="home-section">
        <div class="section-heading">
            <div>
                <h3>Categorías disponibles</h3>
                <p>Desplázate horizontalmente y cambia de categoría sin perder el contexto actual.</p>
            </div>
            <div class="section-heading__actions">
                <span class="section-badge" *ngIf="!loadingCategories">{{ categories.length }} categorías</span>
                <div class="section-heading__buttons">
                    <button mat-icon-button type="button" (click)="reset()" [matTooltip]="'Actualizar terapeutas'">
                        <mat-icon>replay</mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="openFilters()" [matTooltip]="'Filtrar terapeutas'">
                        <mat-icon>tune</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="active-filters-bar" *ngIf="hasActiveFilters">
            <div>
                <span>Filtros activos</span>
                <p>{{ activeFiltersLabel }}</p>
            </div>
            <button mat-stroked-button type="button" (click)="clearFilters()" matTooltip="Quita los filtros y vuelve a mostrar todos los terapeutas de esta categoría">
                Limpiar filtros
            </button>
        </div>

        <div class="categories-loading" *ngIf="loadingCategories">
            <mat-spinner diameter="42"></mat-spinner>
            <p>Cargando categorías...</p>
        </div>

        <div class="categories-rail" *ngIf="!loadingCategories">
            <button
                type="button"
                *ngFor="let c of categories"
                class="category-card"
                [class.category-card--active]="cat_Id === c.id"
                (click)="goCategorie(c.id, ('cat' + c.id))"
            >
                <img [src]="getCategoryImage(c)" (error)="setDefaultPic($event)" [alt]="c.name">
                <span class="category-card__overlay"></span>
                <span class="category-card__selected-badge" *ngIf="cat_Id === c.id">
                    <mat-icon>check</mat-icon>
                    Seleccionada
                </span>
                <span class="category-card__meta">
                    <small>{{ cat_Id === c.id ? 'Seleccionada' : 'Explorar' }}</small>
                    <strong>{{ c.name }}</strong>
                </span>
            </button>
        </div>
    </section>

    <section class="home-section therapists-section">
        <div class="section-heading section-heading--results">
            <div>
                <h3>Terapeutas especialistas</h3>
                <p>{{ doctorsCountLabel }}</p>
            </div>
            <span class="section-badge section-badge--highlight" *ngIf="!loadingDoctors && categories.length > 0">
                {{ activeCategoryName }}
            </span>
        </div>

        <div class="therapists-loading" *ngIf="loadingDoctors">
            <mat-spinner diameter="48"></mat-spinner>
            <div class="therapists-loading__copy">
                <p>{{ hasActiveFilters ? 'Buscando terapeutas con filtros...' : 'Cargando terapeutas...' }}</p>
                <small *ngIf="hasActiveFilters">{{ activeFiltersLabel }}</small>
            </div>
        </div>

        <div class="home-empty-state" *ngIf="!loadingDoctors && doctorsLoaded && categories.length > 0 && doctors.length === 0">
            <div class="empty-state__icon">
                <mat-icon>search_off</mat-icon>
            </div>
            <h4>Sin terapeutas disponibles</h4>
            <p>No encontramos perfiles activos en esta categoría por el momento. Intenta cambiar de categoría o actualizar la lista.</p>
        </div>

        <section class="therapists-grid" *ngIf="!loadingDoctors && doctors.length > 0">
            <article *ngFor="let d of doctors" class="therapist-card animated fadeIn">
                <div class="therapist-card__header">
                    <div class="therapist-card__avatar">
                        <img [src]="getDoctorPhoto(d)" (error)="setDefaultPic($event)" [alt]="d.first_name + ' ' + d.last_name">
                    </div>

                    <div class="therapist-card__identity">
                        <p class="therapist-card__specialty">{{ activeCategoryName }}</p>
                        <h4>{{ d.first_name }} {{ d.last_name }}</h4>
                    </div>
                </div>

                <div class="therapist-card__stats">
                    <span class="info-pill info-pill--rating" *ngIf="getDoctorRating(d) > 0">
                        <mat-icon>star</mat-icon>
                        {{ getDoctorRatingLabel(d) }} estrellas
                    </span>
                    <span class="info-pill" *ngIf="getReviewCount(d) > 0">
                        {{ getReviewLabel(d) }}
                    </span>
                    <span class="info-pill info-pill--muted">
                        {{ getExperienceLabel(d) }}
                    </span>
                </div>

                <p class="therapist-card__description" [matTooltip]="getDoctorSummary(d)">
                    {{ getDoctorSummary(d) }}
                </p>

                <div class="therapist-card__actions">
                    <button
                        mat-button
                        type="button"
                        class="therapist-card__resume"
                        *ngIf="hasResume(d)"
                        (click)="openPdfModal(getResumeUrl(d))"
                    >
                        Ver currículum
                    </button>
                    <button
                        mat-flat-button
                        type="button"
                        class="therapist-card__cta"
                        (click)="bookingNow(d.id)"
                    >
                        Agendar cita
                    </button>
                </div>
            </article>
        </section>
    </section>
</div>
